import { FilterOption } from './data-table-toolbar';

export function splitKeyValuePair(pair: string) {
  const separator = pair.indexOf(':');
  return separator === -1
    ? { key: pair, value: '' }
    : { key: pair.slice(0, separator), value: pair.slice(separator + 1) };
}

export function searchKeyValueFilterOptions(
  options: FilterOption[],
  search: string,
) {
  const term = search.trim().toLocaleLowerCase();
  if (!term) {
    return options;
  }

  return options.filter(({ value }) =>
    value.toLocaleLowerCase().includes(term),
  );
}

export function selectKeyValuePair(pairs: string[], pair: string) {
  if (pairs.includes(pair)) {
    return pairs.filter((activePair) => activePair !== pair);
  }

  const { key } = splitKeyValuePair(pair);
  return [
    ...pairs.filter((activePair) => splitKeyValuePair(activePair).key !== key),
    pair,
  ];
}
